module.exports = __webpack_public_path__ + "img/bannerRed.072b6fa9.jpg";